export interface ReleaseSchedule {
  weekday: number;
  hour: number;
  minute: number;
  label: string;
}

export const RELEASE_SCHEDULE: ReleaseSchedule = {
  weekday: 1,
  hour: 18,
  minute: 0,
  label: "Every Monday",
};
